import { render, staticRenderFns } from "./listado_de_cantidad_eventos_por_gestion_sector_nuevos_y_reingresos.vue?vue&type=template&id=609135ae"
import script from "./listado_de_cantidad_eventos_por_gestion_sector_nuevos_y_reingresos.vue?vue&type=script&lang=js"
export * from "./listado_de_cantidad_eventos_por_gestion_sector_nuevos_y_reingresos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports